module.exports = __webpack_public_path__ + "media/images/countryrect/cu-d31889f24f37353694f4cca360acccb6.svg";